import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SEOService } from 'src/app/shared/seo.service';

@Component({
  selector: 'app-index-course',
  templateUrl: './index-course.component.html',
  styleUrls: ['./index-course.component.css']
})
export class IndexCourseComponent implements OnInit {
  constructor(private modalService: NgbModal, private seoService:SEOService) { }
  navClass = 'bg-white';
  showNavigationArrows = false;
  showNavigationIndicators = false;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 3
      }
    },
    nav: false
  };

  ngOnInit(): void {

    this.setMeta();
  }
  /**
    * Open modal for show the video
    * @param content content of modal
    */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }


  setMeta() {
    var desc;
    var keys;
    var title

    keys = 'Pratiu Öğrenciler, Öğrenciler';
    title = 'pratiu - Öğrenciler';
    desc = title;

    this.seoService.updateDescription(desc);
    this.seoService.updateKeywords(keys);
    this.seoService.updateTitle(title); 
  }


}
